import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';
import { ICON_BUTTON_ICONS } from '../../../buttons/IconButton';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import {
  resolveFinancialSource,
  dataSourceClass,
  GROSS_PROFIT_TOOLTIP
} from '../../../../utils/constants/dataSources';

/**
 * SummarySalesRow
 *
 * Sales (€M) row for the General tab Summary card: revenue value with an
 * optional gross-profit indicator and self-disclosure (basic) styling/tooltips.
 * The `showSalesRow` guard stays in the parent (shown when the user can't view
 * extended data, i.e. the Financials card shows sales instead).
 *
 * @param {Object} props
 * @param {Object} props.company - Company data object
 */
const SummarySalesRow = ({ company = {} }) => {
  return (
    <div className="card-row">
      <div
        className={`property ${dataSourceClass(resolveFinancialSource({ isBasic: company.isRevenueBasic }))}`}
      >
        Sales (€M)
      </div>
      <div className="value revenue">
        {company.revenue ? (
          <>
            {!!company.isRevenueGrossProfit && (
              <>
                <div
                  id={'sales-exclamation-company-details-general-tab-summary'}
                  className="default-black-info-circle-wrap"
                >
                  <img src={ICON_BUTTON_ICONS.INFO_CIRCLE} alt="" />
                </div>
                <Tooltip
                  anchorSelect={`#sales-exclamation-company-details-general-tab-summary`}
                  multiline={true}
                  variant="dark"
                  place="bottom-center"
                  opacity={1}
                  content={<>{GROSS_PROFIT_TOOLTIP}</>}
                />
              </>
            )}
            <font
              id={'sales-company-details-general-tab-summary'}
              style={company.isRevenueBasic ? { color: '#348cf9' } : {}}
            >
              {company.revenue}
            </font>
            <span
              className="apostrophe-year"
              style={company.isRevenueBasic ? { color: '#348cf9' } : {}}
            >
              &lsquo;
              {company.revenueYear?.toString?.()?.slice?.(-2) || PUNCTUATION.EMPTY_VALUE}
            </span>
            {!!company.isRevenueBasic && (
              <Tooltip
                anchorSelect={`#sales-company-details-general-tab-summary`}
                multiline={true}
                variant="dark"
                place="bottom-center"
                opacity={1}
                content={<>Based on self-disclosure or estimate</>}
              />
            )}
          </>
        ) : (
          PUNCTUATION.EMPTY_VALUE
        )}
      </div>
    </div>
  );
};

SummarySalesRow.propTypes = {
  company: PropTypes.object
};

export default SummarySalesRow;
